import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense } from "react";
import { MissingCourseResource, UserLimitationResource } from "@ploy-lib/rest-resources";
import { useResource } from "@rest-hooks/core";
import { Banner } from "@ploy-ui/core";
import { FormattedMessage } from "react-intl";
import BlockIcon from "@material-ui/icons/Block";
import { Paper, Typography } from "@material-ui/core";
function UserLimitationsBannerInternal() {
    const userLimitations = useResource(UserLimitationResource.detail(), {});
    const { courses = [], errors = [] } = useResource(MissingCourseResource.detail(), {});
    if (!userLimitations || !userLimitations.MissingRequiredCourse)
        return null;
    return (_jsx(Banner, { iconComponent: _jsx(BlockIcon, {}), description: _jsx(FormattedMessage, { id: "core.user-limitations.description", defaultMessage: "Missing required courses.", description: "User has not completed required courses", values: {
                CourseLinks: courses?.map(course => {
                    return (course.courseUrl && (_jsx("a", { href: course.courseUrl, target: "_blank", rel: "noopener noreferrer", children: ` - ${course.courseName || "Zelo Kurs"}` })));
                }),
                ErrorMessages: errors && (_jsx(Paper, { elevation: 2, style: { padding: 16, marginTop: 8 }, children: _jsx("ul", { children: errors?.map(err => {
                            return (err && (_jsx("li", { children: _jsx(Typography, { variant: "caption", children: err }) })));
                        }) }) }))
            } }) }));
}
export default function UserLimitationsBanner() {
    return (_jsx(Suspense, { fallback: null, children: _jsx(UserLimitationsBannerInternal, {}) }));
}
//# sourceMappingURL=UserLimitationsBanner.js.map